import { Contact, ContactForm } from 'modules/Contacts/models';

export default function normalizeValues(
  id: string,
  values: ContactForm
): Contact {
  return { ...values, id };
}
